var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('navbar',{attrs:{"text":_vm.$t('LeftPanel_subtitle_territorialUnitcaps')}}),_vm._v(" "),_c('DxTerritorialUnit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }